/**
 * @fileoverview GET handler for the "/apps/engagement_reports/engagement_report_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsEngagementReportData } from "./constants";
import type { EngagementReportData } from "./types";

export const getAppsEngagementReportsEngagementReportData = reactQueryFetcherAdapter(
  appsEngagementReportsEngagementReportData,
  (signal: AbortSignal, reportId: string, appGroupId: string): Promise<EngagementReportData> => {
    return fetch(
      `/apps/engagement_reports/engagement_report_data/${appGroupId}`,
      "GET",
      { report_id: reportId },
      { signal }
    );
  }
);
